import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  breakerHeader: {
    id: 'homeBreakerPanels.breakerHeader',
    description: 'Header for breaker panels page',
    defaultMessage: 'Breaker Panels',
  },
  searchPlaceholder: {
    id: 'homeBreakerPanels.searchPlaceholder',
    description: 'Panel Table search placeholder',
    defaultMessage: 'Search',
  },
  headerName: {
    id: 'homeBreakerPanels.headerName',
    description: 'Panel Table name header',
    defaultMessage: 'Name',
  },
  headerType: {
    id: 'homeBreakerPanels.headerType',
    description: 'Panel Table type header',
    defaultMessage: 'Type',
  },
  headerRoom: {
    id: 'homeBreakerPanels.headerRoom',
    description: 'Panel Table room header',
    defaultMessage: 'Room',
  },
  headerSize: {
    id: 'homeBreakerPanels.headerSize',
    description: 'Panel Table size header',
    defaultMessage: 'Size',
  },
  hierarchy: {
    id: 'homeBreakerPanels.hierarchy',
    description: 'Panel hierarchy',
    defaultMessage: 'Hierarchy',
  },
  mainBreakerFeed: {
    id: 'homeBreakerPanels.mainBreakerFeed',
    description: 'Panel main breaker feed',
    defaultMessage: 'Main Breaker Feed',
  },
  phase: {
    id: 'homeBreakerPanels.phase',
    description: 'Panel phase',
    defaultMessage: 'Phase',
  },
  backupPowerSource: {
    id: 'homeBreakerPanels.backupPowerSource',
    description: 'Panel backup power source',
    defaultMessage: 'Backup Power Source',
  },
  linkedPBC: {
    id: 'homeBreakerPanels.linkedPBC',
    description: 'Panel linked PBC',
    defaultMessage: 'PBC/Director',
  },
  columns: {
    id: 'homeBreakerPanels.columns',
    description: 'Panel columns',
    defaultMessage: 'Columns',
  },
  installation: {
    id: 'homeBreakerPanels.installation',
    description: 'Panel installation',
    defaultMessage: 'Installation',
  },
  splitPhase: {
    id: 'homeBreakerPanels.splitPhase',
    description: 'Text for split phase panel',
    defaultMessage: 'Split Phase',
  },
  threePhase: {
    id: 'homeBreakerPanels.threePhase',
    description: 'Text for three phase panel',
    defaultMessage: 'Three Phase',
  },
  slots: {
    id: 'homeBreakerPanels.slots',
    description: 'Number of slots for the panel',
    defaultMessage: 'slots',
  },
  headerSlotNumber: {
    id: 'homeBreakerPanels.headerSlotNumber',
    description: 'Table header',
    defaultMessage: 'Slot #',
  },
  headerDeviceType: {
    id: 'homeBreakerPanels.headerDeviceType',
    description: 'Table header',
    defaultMessage: 'Device Type',
  },
  headerChannel: {
    id: 'homeBreakerPanels.headerChannel',
    description: 'Table header',
    defaultMessage: 'Channel',
  },
  headerCircuitName: {
    id: 'homeBreakerPanels.headerCircuitName',
    description: 'Table header',
    defaultMessage: 'Circuit Name',
  },
  left: {
    id: 'homeBreakerPanels.left',
    description: 'Label for mobile table tiles',
    defaultMessage: 'Left',
  },
  right: {
    id: 'homeBreakerPanels.right',
    description: 'Label for mobile table tiles',
    defaultMessage: 'Right',
  },
  deviceUID: {
    id: 'homeBreakerPanels.deviceUID',
    description: 'Breaker info device UID',
    defaultMessage: 'Device UID',
  },
  hardwareGeneration: {
    id: 'homeBreakerPanels.hardwareGeneration',
    description: 'Breaker info hardware generation',
    defaultMessage: 'Hardware Generation',
  },
  panel: {
    id: 'homeBreakerPanels.panel',
    description: 'Breaker info panel',
    defaultMessage: 'Panel',
  },
  slotNumber: {
    id: 'homeBreakerPanels.slotNumber',
    description: 'Breaker info panel',
    defaultMessage: 'Slot Number',
  },
  firmwareVersion: {
    id: 'homeBreakerPanels.firmwareVersion',
    description: 'Breaker info panel',
    defaultMessage: 'Firmware Version',
  },
  firmwareUpgrade: {
    id: 'homeBreakerPanels.firmwareUpgrade',
    description: 'Breaker info panel',
    defaultMessage: 'Firmware Upgrade',
  },
  pairedPBCName: {
    id: 'homeBreakerPanels.pairedPBCName',
    description: 'Breaker info panel',
    defaultMessage: 'PBC/Director Name',
  },
  pairedPBCUID: {
    id: 'homeBreakerPanels.pairedPBCUID',
    description: 'Breaker info panel',
    defaultMessage: 'PBC/Director UID',
  },
  critical: {
    id: 'homeBreakerPanels.critical',
    description: 'Breaker info panel',
    defaultMessage: 'Critical',
  },
  override: {
    id: 'homeBreakerPanels.override',
    description: 'Breaker info panel',
    defaultMessage: 'Override',
  },
  backToPanels: {
    id: 'homeBreakerPanels.backToPanels',
    description: 'Nav back to panels',
    defaultMessage: 'Back to Breaker Panels',
  },
  backToDevices: {
    id: 'homeBreakerPanels.backToDevices',
    description: 'Nav back to devices',
    defaultMessage: 'Back to All Devices',
  },
  yes: {
    id: 'homeBreakerPanels.yes',
    description: 'Critical',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'homeBreakerPanels.no',
    description: 'Critical',
    defaultMessage: 'No',
  },
  on: {
    id: 'homeBreakerPanels.on',
    description: 'Channel on',
    defaultMessage: 'On',
  },
  off: {
    id: 'homeBreakerPanels.off',
    description: 'Channel off',
    defaultMessage: 'Off',
  },
  online: {
    id: 'homeBreakerPanels.online',
    description: 'Channel online',
    defaultMessage: 'Online',
  },
  offline: {
    id: 'homeBreakerPanels.offline',
    description: 'Channel offline',
    defaultMessage: 'Offline',
  },
})
